"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protocolRouterServiceDeclaration = void 0;
const get_schema_overrides_api_1 = require("./get-schema-overrides-api");
exports.protocolRouterServiceDeclaration = {
    getSchemaOverrides: get_schema_overrides_api_1.getSchemaOverridesDeclaration,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdG9jb2wtcm91dGVyLXNlcnZpY2UtZGVjbGFyYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvdG9jb2wtcm91dGVyLXNlcnZpY2UtZGVjbGFyYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEseUVBQTBFO0FBRTdELFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsa0JBQWtCLEVBQUUsd0RBQTZCO0NBQ2xELENBQUEifQ==